/**
 * Topbar — current screen title (derived from URL) and logout button.
 * Stays slim so the body has maximum vertical space.
 */
import { LogOut } from "lucide-react";
import { useLocation } from "react-router-dom";

import { useAuth } from "../auth/AuthProvider";

const TITLES: Record<string, string> = {
  "/dashboard":     "Dashboard",
  "/members":       "Members",
  "/payments":      "Payments",
  "/plans":         "Membership plans",
  "/content/posts": "Posts",
  "/content/pages": "Pages",
  "/events":        "Events",
  "/gallery":       "Gallery",
  "/committee":     "Committee",
  "/settings":      "Site settings",
  "/audit":         "Audit log",
  "/users":         "Users",
};

export function Topbar() {
  const { user, logout } = useAuth();
  const { pathname } = useLocation();
  const title = TITLES[pathname] ?? "KRCL Admin";

  return (
    <header className="flex h-14 items-center justify-between border-b border-stone-200 bg-white px-6">
      <h1 className="text-lg font-semibold text-stone-900">{title}</h1>

      <button
        type="button"
        onClick={logout}
        className="inline-flex items-center gap-2 rounded-md px-3 py-1.5 text-sm text-stone-700 hover:bg-stone-100"
      >
        <LogOut className="size-4" />
        <span>Sign out</span>
        <span className="hidden text-xs text-stone-400 md:inline">({user?.email})</span>
      </button>
    </header>
  );
}
